import React from 'react'
import { useTranslation } from 'react-i18next'
import {Button} from 'antd'
import {LeftOutlined, SaveOutlined} from '@ant-design/icons'

import {useScreenType} from '@/hooks'

import {FormNavigationProps} from './props'
import styles from './FormNavigation.scss'

export const FormNavigation: React.FC<FormNavigationProps> = ({
    backButton,
    saveButton,
    verifyButton,
    editButton,
    continueButton,
    saveAndContinueButton,
    submitButton,
    isLoading = false,
    className
}) => {
    const { t } = useTranslation()
    const {isMobile, isTablet} = useScreenType()

    const containerClass =
        isMobile || isTablet
            ? `${styles.navigationContainer} ${styles.navigationContainerMobile} ${className || ''}`
            : `${styles.navigationContainer} ${className || ''}`

    return (
        <div className={containerClass}>
            <div className={styles.leftButtons}></div>

            <div className={styles.rightButtons}>
                {backButton?.show && (
                    <Button
                        type='link'
                        icon={backButton.showIcon && <LeftOutlined />}
                        onClick={backButton.onClick}
                        className={styles.backButton}
                        disabled={backButton.disabled}
                        {...backButton.props}
                    >
                        {backButton.text || t('FormNavigation.back')}
                    </Button>
                )}

                {!isMobile && saveButton?.show && (
                    <Button
                        type='default'
                        icon={<SaveOutlined />}
                        onClick={saveButton.onClick}
                        className={styles.saveButton}
                        loading={
                            saveButton.loading ||
                            (isLoading &&
                                !continueButton?.show &&
                                !saveAndContinueButton?.show &&
                                !submitButton?.show)
                        }
                        disabled={saveButton.disabled}
                        {...saveButton.props}
                    >
                        {saveButton.text || t('FormNavigation.save')}
                    </Button>
                )}

                {isMobile && saveButton?.show && (
                    <Button
                        type='default'
                        icon={<SaveOutlined />}
                        onClick={saveButton.onClick}
                        className={styles.saveButton}
                        loading={
                            saveButton.loading ||
                            (isLoading &&
                                !continueButton?.show &&
                                !saveAndContinueButton?.show &&
                                !submitButton?.show)
                        }
                        disabled={saveButton.disabled}
                        {...saveButton.props}
                    >
                        {saveButton.text || t('FormNavigation.save')}
                    </Button>
                )}

                {saveAndContinueButton?.show && (
                    <Button
                        type='primary'
                        onClick={saveAndContinueButton.onClick}
                        className={styles.saveAndContinueButton}
                        loading={
                            saveAndContinueButton.loading ||
                            (isLoading && !submitButton?.show && !continueButton?.show)
                        }
                        disabled={saveAndContinueButton.disabled}
                        {...saveAndContinueButton.props}
                    >
                        {saveAndContinueButton.text || t('FormNavigation.saveAndContinue')}
                    </Button>
                )}

                {verifyButton?.show && (
                    <Button
                        type='primary'
                        onClick={verifyButton.onClick}
                        className={styles.verifyButton}
                        loading={verifyButton.loading}
                        disabled={verifyButton.disabled}
                        {...verifyButton.props}
                    >
                        {verifyButton.text || 'Verify'}
                    </Button>
                )}

                {editButton?.show && (
                    <Button
                        type='default'
                        onClick={editButton.onClick}
                        className={styles.editButton}
                        disabled={editButton.disabled}
                        {...editButton.props}
                    >
                        {editButton.text || 'Edit'}
                    </Button>
                )}

                {continueButton?.show && (
                    <Button
                        type='primary'
                        onClick={continueButton.onClick}
                        className={styles.continueButton}
                        loading={
                            continueButton.loading ||
                            (isLoading && !submitButton?.show && !saveAndContinueButton?.show)
                        }
                        disabled={continueButton.disabled}
                        {...continueButton.props}
                    >
                        {continueButton.text || t('FormNavigation.continue')}
                    </Button>
                )}

                {submitButton?.show && (
                    <Button
                        type='primary'
                        onClick={submitButton.onClick}
                        className={styles.submitButton}
                        loading={submitButton.loading || isLoading}
                        disabled={submitButton.disabled}
                        size='large'
                        {...submitButton.props}
                    >
                        {submitButton.text || t('FormNavigation.submit')}
                    </Button>
                )}
            </div>
        </div>
    )
}
